module.exports = __webpack_public_path__ + "static/media/IMM.82386c32.png";